import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import { SUBSCRIPTION_PRODUCT, EMAIL_REGEX } from '../../constants';
import { useAuth } from '../../AuthContext';
import { useCallback, useEffect, useState } from 'react';

export default function Profile() {
  const auth = useAuth();
  const [userEdit, setUserEdit] = useState({ email: auth.user.email, name: auth.user.name || '' });
  const [userPassword, setUserPassword] = useState({ current: '', password: '', password2: '' });
  const [userError, setUserError] = useState(null);
  const [userSuccess, setUserSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  
  const userChanged = (e, key) => {
    setUserEdit(old => ({ ...old, [key]: e.target.value }));
  }
  const passwordChanged = (e, key) => {
    setUserPassword(old => ({ ...old, [key]: e.target.value }));
  }
  const saveUserChanges = useCallback(() => {
    setUserSuccess(false);
    setPasswordError(null);
    if (!userEdit.email?.length || !EMAIL_REGEX.test(userEdit.email)) {
      setUserError('Please enter a valid email address');
      return;
    }
    console.log('userEdit', userEdit, auth.user._id);
    auth.request('/api/user/profile', {
      email: userEdit.email,
      name: userEdit.name,
      _id: auth.user._id
    }).then(res => {
      console.log('userEdit', res);
      if (res.status === 200) {
        setUserSuccess(true);
      } else if (res?.data?.error) {
        setUserError(res.data.error);
      } else {
        setUserError('An unknown error occurred');
      }
    });
    // .catch(res => {
    //   // setUserError(error.error || error.message);
    //   setUserError(res?.data?.error || 'An unknown error occurred');
    // });
  }, [userEdit, auth.user]);
  
  const savePasswordChanges = useCallback(() => {
    setPasswordSuccess(false);
    setPasswordError(null);
    console.log('password', userPassword);
    if (!userPassword.current) {
      setPasswordError('Please enter your current password');
      return;
    }
    if (
      userPassword.password.length < 8 ||
      userPassword.password2.length < 8
    ) {
      setPasswordError('Password needs to be at least 8 characters');
      return;
    }
    if (userPassword.password !== userPassword.password2) {
      setPasswordError('Passwords did not match');
      return;
    }

    auth.request('/api/user/password', {
      ...userPassword,
      _id: auth.user._id
    }).then(res => {
      console.log('password', res);
      if (res.status === 200) {
        setPasswordSuccess(true);
      } else if (res?.data?.error) {
        setPasswordError(res.data.error);
      } else {
        setPasswordError('An unknown error occurred');
      }
    });

  }, [userPassword, auth.user]);

  // useEffect(() => {
  //   fetch('/api/user/devices').then(res => res.json()).then(data => {
  //     console.log('devices', data);
  //   });
  // }, []);
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Profile
      </Typography>

      <Grid2
        container
        spacing={2}
        // columns={2}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >

   
        <Grid2 size={12}>

          <Card sx={{ mb: 2 }}>
            <CardHeader title="User Settings" subheader="Your name and email" />
            <CardContent sx={{ p: 4 }}>
              <Grid2 container={true} spacing={2} sx={{ alignItems: 'center' }}>
                <Grid2 size={{ sm: 12, md: 3 }}>
                  <Typography>Name</Typography>
                </Grid2>
                <Grid2 size={{ sm: 12, md: 8 }}>
                  <TextField
                    fullWidth
                    value={userEdit.name}
                    onChange={(e) => userChanged(e, 'name')}
                  />
                </Grid2>
                <Grid2 size={{ sm: 12, md: 3 }}>
                  <Typography>Email</Typography>
                </Grid2>
                <Grid2 size={{ sm: 12, md: 8 }}>
                  <TextField
                    // disabled={true}
                    // slotProps={{ input: { readOnly: true }}}
                    fullWidth
                    value={userEdit.email}
                    onChange={(e) => userChanged(e, 'email')}
                    // helperText="Please contact support if you wish to change the email address associated with this account"
                  />
                </Grid2>
              </Grid2>
            </CardContent>
            <CardActions>
              <Grid2 container={true} spacing={2} sx={{ p: 2 }} flex={1}>
                <Grid2 offset={{ sm: 0, md: 3 }} size={{ sm: 12, md: 8 }}>
                  <Button onClick={saveUserChanges} fullWidth variant="outlined">Save Changes</Button>
                  {userError ? (
                    <Alert sx={{ mt: 2 }} severity="error">{userError}</Alert>
                  ) : null}
                  {userSuccess ? (
                    <Alert sx={{ mt: 2 }} severity="success">User details have been updated</Alert>
                  ) : null}
                </Grid2>
              </Grid2>
            </CardActions>
            {/* <CardActions>
              <Grid2 container={true} spacing={2} sx={{ alignItems: 'center' }}>
                <Grid2>
                  <Button fullWidth variant="outlined">Save Changes</Button>
                </Grid2>
              </Grid2>
            </CardActions> */}
          </Card>
        </Grid2>
        
        <Grid2 size={12}>
          <Card sx={{ mb: 2 }}>
            <CardHeader title="Update Password" subheader="Choose a new password for your account" />
            <CardContent sx={{ p: 4 }}>
              <Grid2 container={true} spacing={2} sx={{ alignItems: 'center' }}>
                <Grid2 size={{ sm: 12, md: 3 }}>
                  <Typography>Current Password</Typography>
                </Grid2>
                <Grid2 size={{ sm: 12, md: 8 }}>
                  <TextField
                    fullWidth
                    type="password"
                    value={userPassword.current}
                    onChange={(e) => passwordChanged(e, 'current')}
                  />
                </Grid2>
                <Grid2 size={{ sm: 12, md: 3 }}>
                  <Typography>New Password</Typography>
                </Grid2>
                <Grid2 size={{ sm: 12, md: 8 }}>
                  <TextField
                    fullWidth
                    type="password"
                    value={userPassword.password}
                    onChange={(e) => passwordChanged(e, 'password')}
                  />
                </Grid2>
                <Grid2 size={{ sm: 12, md: 3 }}>
                  <Typography>Confirm New Password</Typography>
                </Grid2>
                <Grid2 size={{ sm: 12, md: 8 }}>
                  <TextField
                    type="password"
                    fullWidth
                    value={userPassword.password2}
                    onChange={(e) => passwordChanged(e, 'password2')}
                  />
                </Grid2>
              </Grid2>

            </CardContent>
            <CardActions>
              <Grid2 container={true} spacing={2} sx={{ p: 2 }} flex={1}>
                <Grid2 offset={{ sm: 0, md: 3 }} size={{ sm: 12, md: 8 }}>
                  <Button onClick={savePasswordChanges} fullWidth variant="outlined">Update Password</Button>
                  {passwordError ? (
                    <Alert sx={{ mt: 2 }} severity="error">{passwordError}</Alert>
                  ) : null}
                  {passwordSuccess ? (
                    <Alert sx={{ mt: 2 }} severity="success">Password has been updated</Alert>
                  ) : null}
                </Grid2>
              </Grid2>
            </CardActions>

          </Card>

        </Grid2>
      </Grid2>



    </Box>
  );
}